
export { default as Link } from "./Link"